import { Directive, Renderer, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[focusElement]'
})
export class FocusDirective implements OnInit {

    constructor(private renderer: Renderer, private elementRef: ElementRef) {}

    ngOnInit() {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement, 'focus', []);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/utilities/focus.directive.ts